module.exports = __webpack_public_path__ + "img/contact-2.8beb0cdf.png";